// src/locales/translations.js

export const translations = {
  en: {
    // Navigation & Headers
    timeClock: "SCHOONER PUNCH CLOCK",
    welcomeBack: "Welcome back,",
    currentStatus: "Current Status",
    signOut: "Sign Out",
    refresh: "Refresh",
    
    // Status
    clockedIn: "Clocked In",
    onBreak: "On Break",
    clockedOut: "Clocked Out",
    
    // Actions
    clockIn: "Clock In",
    clockOut: "Clock Out",
    startBreak: "Start Break",
    endBreak: "End Break",
    
    // Sections
    breakTimer: "Break Timer",
    shiftNotes: "Shift Notes",
    addNotes: "Add Notes",
    waitTime: "Start Wait Time",
    waitTimeSheet: "Wait Time Sheet",
    smartWorkDetails: "Smart Work Details",
    recentTimeEntries: "Recent Time Entries",
    myWeeklyHours: "My Weekly Hours",
    account: "Account",
    
    // Smart Work Details
    smartWorkDetailsSubtitle: "Add work details for any shift",
    selectShiftPrompt: "Select a shift to add or view work details:",
    today: "Today",
    yesterday: "Yesterday",
    noDetails: "No details",
    entries: "entries",
    multiStop: "Multi-Stop",
    inProgress: "In Progress",
    
    // Time Entries Table
    date: "Date",
    clockInTime: "Clock In",
    clockOutTime: "Clock Out",
    status: "Status",
    hours: "Hours",
    noTimeEntries: "No time entries yet",
    
    // Weekly Hours
    totalHours: "Total Hours",
    avgPerDay: "Avg/Day",
    daysWorked: "Days Worked",
    downloadMyTimesheet: "Download My Timesheet",
    
    // Days of week
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    
    // Account Section
    changePassword: "Change Password",
    deleteAccount: "Delete Account",
    
    // Dialogs
    addNotesTitle: "Add Notes & Details",
    addNotesPlaceholder: "Add waiting times, delays, equipment issues, or other shift details...",
    addNotesExamples: 'Examples: "Waiting 30 min for loading", "Traffic delay on I-95", "Equipment maintenance"',
    saveNotes: "Save Notes",
    cancel: "Cancel",
    placeYouWaited: "Place You Waited",
    startTypingLocation: "Start typing a location",
    truckNumber: "Truck Number",
    trailerNumber: "Trailer Number",
    waitingReason: "Reason for Waiting",
    waitForLoading: "Wait for loading",
    waitForUnloading: "Wait for unloading",
    noProduct: "No product",
    outages: "Outages",
    systemProblem: "System problem",
    equipmentProblem: "Equipment problem",
    otherReason: "Other reason",
    describeReason: "Describe the reason",
    trucksAheadCount: "How many trucks are ahead of you?",
    trucksAhead: "Who is ahead of you?",
    trucksAheadPlaceholder: "Enter company names or truck/unit numbers",
    bolCanBeAddedLater: "BOL number required when ending the wait.",
    bolRequiredToSubmit: "BOL number is required to submit the completed sheet.",
    currentlyWaiting: "Currently Waiting",
    startedAt: "Started at",
    startWaiting: "Start Waiting",
    endAndSubmitWait: "End Waiting & Submit",
    keepWaiting: "Keep Waiting",
    cancelWaitTime: "Cancel Wait Time",
    cancelWaitConfirm: "Cancel this active wait time? It will not be submitted for billing.",
    waitTimeStarted: "Waiting time started.",
    waitTimeSubmitted: "Wait time sheet submitted.",
    waitTimeCancelled: "Waiting time cancelled.",
    waitTimeStartFailed: "Unable to start waiting time.",
    waitTimeSubmitFailed: "Unable to submit the wait time sheet.",
    waitTimeCancelFailed: "Unable to cancel waiting time.",
    saving: "Saving...",
    
    // Clock Out Confirmation
    confirmClockOut: "Confirm Clock Out",
    areYouSureClockOut: "Are you sure you want to clock out?",
    yesClockOut: "Yes, Clock Out",
    
    // Start Break Confirmation
    confirmStartBreak: "Confirm Start Break",
    areYouSureStartBreak: "Are you sure you want to start your break?",
    yesStartBreak: "Yes, Start Break",
    
    // End Break Confirmation
    confirmEndBreak: "Confirm End Break",
    areYouSureEndBreak: "Are you sure you want to end your break?",
    yesEndBreak: "Yes, End Break",
    
    // Mileage
    weeklyMileageUpdate: "Weekly Mileage Update",
    enterCurrentMileage: "Please enter your truck's current mileage",
    unitNumber: "Unit Number",
    unitNumberPlaceholder: "e.g., 123",
    currentMileage: "Current Mileage",
    mileagePlaceholder: "e.g., 125000",
    lastUnitDrove: "Last unit you drove:",
    submitAndClockIn: "Submit & Clock In",
    skipForNow: "Skip for now (not recommended)",
    submitting: "Submitting...",
    
    // Notifications
    successClockIn: "Successfully clocked in",
    breakStarted: "Break started",
    breakEnded: "Break ended",
    clockedOutSuccess: "Clocked out successfully",
    workDetailsSaved: "Work details saved successfully",
    notesSaved: "Notes saved successfully",
    notesSavedTemp: "Notes saved temporarily (will be included in work details)",
    mileageRecorded: "Mileage recorded and clocked in successfully",
    
    // Errors
    failedToClockIn: "Failed to clock in",
    failedToStartBreak: "Failed to start break",
    failedToEndBreak: "Failed to end break",
    unableToClockOut: "Unable to clock out. Please try again.",
    failedToSaveNotes: "Failed to save notes. Please try again.",
    noTimeEntryForNotes: "No time entry available for notes",
    
    // Break Timer Messages
    breakInProgress: "Your break is in progress. End your break when you're ready to resume work.",
    breakExceeded30: "⚠️ Break has exceeded 30 minutes. Remember to end your break when ready.",
  
    
    // Time Fix Requests
    requestTimeFix: "Request Time Fix",
    timeFixRequests: "Time Fix Requests",
    submitRequest: "Submit Request",
    selectShiftToFix: "Select shift to fix",
    fixClockIn: "Fix Clock In Time",
    fixClockOut: "Fix Clock Out Time",
    fixBreakTime: "Fix Break Times",
    orTypeManually: "Or describe the fix needed:",
    explainFix: "Explain what needs to be fixed...",
    requestSubmitted: "Time fix request submitted successfully",
    pendingRequests: "Pending Requests",
    completedRequests: "Completed Requests",
    markAsFixed: "Mark as Fixed",
    requestDetails: "Request Details",
    noRequests: "No time fix requests",
    breakStartTime: "Break Start Time",
    breakEndTime: "Break End Time",
    whenDidBreakStart: "When did the break start?",
    whenDidBreakEnd: "When did the break end?",
    
    // Additional translations for TimeFixRequestDialog
    pleaseSelectShift: "Please select a shift to fix",
    fixType: "Fix Type",
    fixBothTimes: "Fix Clock In & Clock Out",
    newClockInTime: "New clock in time",
    newClockOutTime: "New clock out time",
    manualDescription: "Manual Description",
    
    // Work Entry Dialog
    addWorkDetails: "Add Work Details",
    editWorkEntry: "Edit Work Entry",
    selectLoadTypePrompt: "Select your load type and enter trip details",
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    step4: "Step 4",
    whatTypeOfLoad: "What type of load are you hauling?",
    gasoline: "Gasoline",
    asphalt: "Asphalt",
    allLocations: "All Locations",
    fuelDeliveryRoutes: "Fuel delivery routes",
    hotMixMaterials: "Hot mix & materials",
    showAllAvailable: "Show all available",
    selectLoadingLocation: "Select Loading Location",
    loadingPlace: "Loading Place",
    enterLoadingPlace: "Enter Loading Place",
    showingGasolineLoading: "Showing gasoline loading locations",
    showingAsphaltLoading: "Showing asphalt loading locations",
    showingAllLoading: "Showing all loading locations",
    selectLoadType: "Select Load Type",
    singleDelivery: "Single Delivery",
    multipleStops: "Multiple Stops",
    standardSinglePickup: "Standard single pickup and delivery - one pickup, one delivery",
    enterDeliveryDetails: "Enter Delivery Details",
    deliveryPlace: "Delivery Place",
    enterDeliveryPlace: "Enter Delivery Place",
    showingGasolineDelivery: "Showing gasoline delivery locations",
    showingAsphaltDelivery: "Showing asphalt delivery locations",
    showingAllDelivery: "Showing all delivery locations",
    pbNumber: "PB Number",
    bolNumber: "BOL Number",
    bolPhotoRequired: "BOL Photo (Required)",
    takeUploadBolPhotos: "Take/Upload BOL Photos",
    addMorePhotos: "Add More Photos",
    addEntry: "Add Entry",
    multipleDeliveryStops: "Multiple Delivery Stops",
    onePickupAt: "One pickup at",
    withDeliveryStops: "with",
    deliveryStops: "delivery stops",
    stopNumber: "Stop #",
    addAnotherDeliveryStop: "Add Another Delivery Stop",
    noEntriesYet: "No entries added yet. Please add at least one entry before continuing.",
    complete: "Complete",
    bolPhoto: "BOL Photo",
    location: "location",
    loadingPlaceholder: "loading place",
    
    // Change Password Dialog
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    passwordMinLength: "Password must be at least 8 characters long",
    currentPasswordRequired: "Current password is required",
    newPasswordRequired: "New password is required",
    passwordsDoNotMatch: "Passwords do not match",
    failedToChangePassword: "Failed to change password",
    passwordChangedSuccess: "Password changed successfully!",
    changing: "Changing...",
    
    // Locations
    other: "Other",
  },
  
  fr: {
    // Navigation & Headers
    timeClock: "SCHOONER PUNCH CLOCK",
    welcomeBack: "Bon retour,",
    currentStatus: "Statut actuel",
    signOut: "Déconnexion",
    refresh: "Actualiser",
    
    // Status
    clockedIn: "Commencé",
    onBreak: "En pause",
    clockedOut: "Terminé",
    
    // Actions
    clockIn: "Commencer",
    clockOut: "Terminer",
    startBreak: "Prendre une pause",
    endBreak: "Terminer la pause",
    
    // Sections
    breakTimer: "Temps de pause",
    shiftNotes: "Notes du poste",
    addNotes: "Ajouter des notes",
    waitTime: "Commencer l’attente",
    waitTimeSheet: "Feuille de temps d'attente",
    smartWorkDetails: "Détails du travail",
    recentTimeEntries: "Heures récentes",
    myWeeklyHours: "Mes heures hebdomadaires",
    account: "Compte",
    
    // Smart Work Details
    smartWorkDetailsSubtitle: "Ajouter des détails de travail pour n'importe quel poste",
    selectShiftPrompt: "Sélectionnez un poste pour ajouter ou voir les détails:",
    today: "Aujourd'hui",
    yesterday: "Hier",
    noDetails: "Pas de détails",
    entries: "entrées",
    multiStop: "Livraison multiple",
    inProgress: "En cours",
    
    // Time Entries Table
    date: "Date",
    clockInTime: "Heure de début",
    clockOutTime: "Heure de fin",
    status: "Statut",
    hours: "Heures",
    noTimeEntries: "Aucune heure enregistrée",
    
    // Weekly Hours
    totalHours: "Heures totales",
    avgPerDay: "Moy/Jour",
    daysWorked: "Jours travaillés",
    downloadMyTimesheet: "Télécharger ma feuille de temps",
    
    // Days of week
    sun: "Dim",
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
    sat: "Sam",
    
    // Account Section
    changePassword: "Changer le mot de passe",
    deleteAccount: "Supprimer le compte",
    
    // Dialogs
    addNotesTitle: "Ajouter des notes et détails",
    addNotesPlaceholder: "Ajoutez les temps d'attente, retards, problèmes d'équipement ou autres détails...",
    addNotesExamples: 'Exemples: "Attente 30 min pour le chargement", "Retard de circulation", "Maintenance du camion"',
    saveNotes: "Enregistrer les notes",
    cancel: "Annuler",
    placeYouWaited: "Lieu d'attente",
    startTypingLocation: "Commencez à taper un lieu",
    truckNumber: "Numéro du camion",
    trailerNumber: "Numéro de la remorque",
    waitingReason: "Raison de l'attente",
    waitForLoading: "Attente pour le chargement",
    waitForUnloading: "Attente pour le déchargement",
    noProduct: "Aucun produit",
    outages: "Panne",
    systemProblem: "Problème de système",
    equipmentProblem: "Problème d'équipement",
    otherReason: "Autre raison",
    describeReason: "Décrivez la raison",
    trucksAheadCount: "Combien de camions sont devant vous?",
    trucksAhead: "Qui est devant vous?",
    trucksAheadPlaceholder: "Entrez les entreprises ou les numéros de camion",
    bolCanBeAddedLater: "Le numéro BOL est requis à la fin de l’attente.",
    bolRequiredToSubmit: "Le numéro BOL est requis pour soumettre la feuille.",
    currentlyWaiting: "Attente en cours",
    startedAt: "Commencé à",
    startWaiting: "Commencer l'attente",
    endAndSubmitWait: "Terminer l'attente et soumettre",
    keepWaiting: "Continuer l'attente",
    cancelWaitTime: "Annuler le temps d'attente",
    cancelWaitConfirm: "Annuler ce temps d'attente? Il ne sera pas soumis pour la facturation.",
    waitTimeStarted: "Temps d'attente commencé.",
    waitTimeSubmitted: "Feuille de temps d'attente soumise.",
    waitTimeCancelled: "Temps d'attente annulé.",
    waitTimeStartFailed: "Impossible de commencer le temps d'attente.",
    waitTimeSubmitFailed: "Impossible de soumettre la feuille de temps d'attente.",
    waitTimeCancelFailed: "Impossible d'annuler le temps d'attente.",
    saving: "Enregistrement...",
    
    // Clock Out Confirmation
    confirmClockOut: "Confirmer la fin",
    areYouSureClockOut: "Êtes-vous sûr de vouloir terminer?",
    yesClockOut: "Oui, terminer",
    
    // Start Break Confirmation
    confirmStartBreak: "Confirmer la pause",
    areYouSureStartBreak: "Êtes-vous sûr de vouloir commencer votre pause?",
    yesStartBreak: "Oui, commencer la pause",
    
    // End Break Confirmation
    confirmEndBreak: "Confirmer la fin de pause",
    areYouSureEndBreak: "Êtes-vous sûr de vouloir terminer votre pause?",
    yesEndBreak: "Oui, terminer la pause",
    
    // Mileage
    weeklyMileageUpdate: "Mise à jour kilométrage hebdomadaire",
    enterCurrentMileage: "Veuillez entrer le kilométrage actuel de votre camion",
    unitNumber: "Numéro d'unité",
    unitNumberPlaceholder: "p. ex., 123",
    currentMileage: "Kilométrage actuel",
    mileagePlaceholder: "p. ex., 125000",
    lastUnitDrove: "Dernière unité conduite:",
    submitAndClockIn: "Soumettre et commencer",
    skipForNow: "Passer pour l'instant (non recommandé)",
    submitting: "Envoi en cours...",
    
    // Notifications
    successClockIn: "Commencé avec succès",
    breakStarted: "Pause débutée",
    breakEnded: "Pause terminée",
    clockedOutSuccess: "Terminé avec succès",
    workDetailsSaved: "Détails du travail enregistrés",
    notesSaved: "Notes enregistrées avec succès",
    notesSavedTemp: "Notes enregistrées temporairement (seront incluses dans les détails du travail)",
    mileageRecorded: "Kilométrage enregistré et commencé avec succès",
    
    // Errors
    failedToClockIn: "Échec de commencer",
    failedToStartBreak: "Échec du démarrage de la pause",
    failedToEndBreak: "Échec de terminer la pause",
    unableToClockOut: "Impossible de terminer. Veuillez réessayer.",
    failedToSaveNotes: "Échec de l'enregistrement des notes. Veuillez réessayer.",
    noTimeEntryForNotes: "Aucune heure disponible pour les notes",
    
    // Break Timer Messages
    breakInProgress: "Votre pause est en cours. Terminez votre pause quand vous êtes prêt.",
    breakExceeded30: "⚠️ La pause a dépassé 30 minutes. N'oubliez pas de terminer votre pause.",
    
    // Time Fix Requests
    requestTimeFix: "Demander une correction",
    timeFixRequests: "Demandes de correction",
    submitRequest: "Soumettre la demande",
    selectShiftToFix: "Sélectionner le poste à corriger",
    fixClockIn: "Corriger l'heure de début",
    fixClockOut: "Corriger l'heure de fin",
    fixBreakTime: "Corriger les temps de pause",
    orTypeManually: "Ou décrivez la correction nécessaire:",
    explainFix: "Expliquez ce qui doit être corrigé...",
    requestSubmitted: "Demande de correction soumise avec succès",
    pendingRequests: "Demandes en attente",
    completedRequests: "Demandes complétées",
    markAsFixed: "Marquer comme corrigé",
    requestDetails: "Détails de la demande",
    noRequests: "Aucune demande de correction",
    breakStartTime: "Heure de début de pause",
    breakEndTime: "Heure de fin de pause",
    whenDidBreakStart: "Quand la pause a-t-elle débuté?",
    whenDidBreakEnd: "Quand la pause s'est-elle terminée?",
    
    // Additional translations for TimeFixRequestDialog
    pleaseSelectShift: "Veuillez sélectionner un poste à corriger",
    fixType: "Type de correction",
    fixBothTimes: "Corriger début et fin",
    newClockInTime: "Nouvelle heure de début",
    newClockOutTime: "Nouvelle heure de fin",
    manualDescription: "Description manuelle",
    
    // Work Entry Dialog
    addWorkDetails: "Ajouter des détails de travail",
    editWorkEntry: "Modifier l'entrée de travail",
    selectLoadTypePrompt: "Sélectionnez votre type de chargement et entrez les détails du voyage",
    step1: "Étape 1",
    step2: "Étape 2",
    step3: "Étape 3",
    step4: "Étape 4",
    whatTypeOfLoad: "Quel type de chargement transportez-vous?",
    gasoline: "Essence",
    asphalt: "Asphalte",
    allLocations: "Tous les emplacements",
    fuelDeliveryRoutes: "Routes de livraison de carburant",
    hotMixMaterials: "Mélange chaud et matériaux",
    showAllAvailable: "Afficher tous les disponibles",
    selectLoadingLocation: "Sélectionner le lieu de chargement",
    loadingPlace: "Lieu de chargement",
    enterLoadingPlace: "Entrer le lieu de chargement",
    showingGasolineLoading: "Affichage des lieux de chargement d'essence",
    showingAsphaltLoading: "Affichage des lieux de chargement d'asphalte",
    showingAllLoading: "Affichage de tous les lieux de chargement",
    selectLoadType: "Sélectionner le type de chargement",
    singleDelivery: "Livraison unique",
    multipleStops: "Arrêts multiples",
    standardSinglePickup: "Ramassage et livraison unique standard - un ramassage, une livraison",
    enterDeliveryDetails: "Entrer les détails de livraison",
    deliveryPlace: "Lieu de livraison",
    enterDeliveryPlace: "Entrer le lieu de livraison",
    showingGasolineDelivery: "Affichage des lieux de livraison d'essence",
    showingAsphaltDelivery: "Affichage des lieux de livraison d'asphalte",
    showingAllDelivery: "Affichage de tous les lieux de livraison",
    pbNumber: "Numéro PB",
    bolNumber: "Numéro BOL",
    bolPhotoRequired: "Photo BOL (Requis)",
    takeUploadBolPhotos: "Prendre/Télécharger des photos BOL",
    addMorePhotos: "Ajouter plus de photos",
    addEntry: "Ajouter une entrée",
    multipleDeliveryStops: "Arrêts de livraison multiples",
    onePickupAt: "Un ramassage à",
    withDeliveryStops: "avec",
    deliveryStops: "arrêts de livraison",
    stopNumber: "Arrêt #",
    addAnotherDeliveryStop: "Ajouter un autre arrêt de livraison",
    noEntriesYet: "Aucune entrée ajoutée pour le moment. Veuillez ajouter au moins une entrée avant de continuer.",
    complete: "Compléter",
    bolPhoto: "Photo BOL",
    location: "emplacement",
    loadingPlaceholder: "lieu de chargement",
    
    // Change Password Dialog
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    passwordMinLength: "Le mot de passe doit comporter au moins 8 caractères",
    currentPasswordRequired: "Le mot de passe actuel est requis",
    newPasswordRequired: "Le nouveau mot de passe est requis",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    failedToChangePassword: "Échec de la modification du mot de passe",
    passwordChangedSuccess: "Mot de passe modifié avec succès!",
    changing: "Modification...",
    
    // Locations
    other: "Autre",
  }
};

export const getTranslation = (key, language = 'en') => {
  return translations[language]?.[key] || translations.en[key] || key;
};
